import { inject } from '@angular/core';
import { LeadApiService } from '@shared/services';
import { PERMISSIONS } from '@shared/constants';
import { TableConfig, PLACEHOLDER_FUNCTIONS } from '../generic-p-table.interfaces';

export const leadTableConfig = (): TableConfig => {
  const leadApiService = inject(LeadApiService);

  return {
    title: 'Danh sách leads',
    entityName: 'lead',
    service: leadApiService,
    method: 'getLeads',
    columns: [
      // { field: 'id', header: 'ID', width: 'min-w-[100px]', sortable: true, type: 'text' },
      { field: 'full_name', header: 'Họ tên', width: 'min-w-[200px]', sortable: true, type: 'text' },
      { field: 'phone', header: 'Số điện thoại', width: 'min-w-[150px]', sortable: true, type: 'text' },
      { field: 'email', header: 'Email', width: 'min-w-[200px]', sortable: true, type: 'text' },
      { field: 'interested_course', header: 'Khoá học', width: 'min-w-[150px]', sortable: true, type: 'text' },
      { field: 'note', header: 'Ghi chú', width: 'min-w-[200px]', sortable: false, type: 'text', styleClass: 'max-w-[200px] truncate block' },
    ],
    features: {
      virtualScroll: true,
      toolbar: true,
      selection: {
        mode: 'multiple',
        metaKeySelection: false,
        dataKey: 'id'
      }
    },
    actions: [
      {
        location: 'toolbar',
        useDefaultStyle: 'add',
        permission: PERMISSIONS.LEAD_CREATE.code,
        onClick: PLACEHOLDER_FUNCTIONS.OPEN_NEW
      },
      {
        location: 'row',
        icon: 'pi pi-eye',
        tooltip: 'Xem chi tiết',
        severity: 'info',
        permission: PERMISSIONS.LEAD_VIEW?.code,
        onClick: PLACEHOLDER_FUNCTIONS.VIEW
      },
      {
        location: 'row',
        useDefaultStyle: 'edit',
        permission: PERMISSIONS.LEAD_UPDATE.code,
        onClick: PLACEHOLDER_FUNCTIONS.EDIT
      },
      {
        location: 'row',
        useDefaultStyle: 'delete',
        permission: PERMISSIONS.LEAD_DELETE.code,
        confirmMessage: 'Bạn có chắc chắn muốn xóa lead này?',
        onClick: PLACEHOLDER_FUNCTIONS.DELETE
      }
    ]
  };
};

